import { useState } from 'react'

interface BHHoverableProps {
  className?: string
  parent: React.ReactNode
  child?: React.ReactNode
  noHoverComponent?: boolean
}

function BHHoverable({ className = '', parent, child }: BHHoverableProps) {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <div
      className={`${className} relative group`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {parent}
      {child !== undefined && (
        <div
          className={`absolute top-[100%] left-0 ${
            isHovering
              ? 'opacity-1 pointer-events-auto'
              : 'opacity-0 pointer-events-none'
          } group-hover:opacity-100 transition-opacity bg-white p-2 rounded border-[1px] border-gray-300 shadow-xl`}
        >
          {child}
        </div>
      )}
    </div>
  )
}

export default BHHoverable
